import { render, staticRenderFns } from "./ManualVerifyAmloButton.vue?vue&type=template&id=6ef1ed3d&"
import script from "./ManualVerifyAmloButton.vue?vue&type=script&lang=js&"
export * from "./ManualVerifyAmloButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports